// src/api/apiService.auth.ts

import { ApiService } from "./apiService";
import { withAuthHooks } from "./auth/auth.ky.hooks";

// ✅ Configure ApiService with auth hooks
export const authenticatedApiService = new ApiService({
  hooks: {
    ...withAuthHooks,
  },
});
